function TitleDescription({ title, description, alignment }) {
    return (
        <div className={`container ${alignment} px-5`}>
            <h2 className='w-full text-5xl leading-[62.1px] tracking-tighter text-avenue-slate-500 max-md:max-w-full max-md:text-4xl'>
                {title}
            </h2>
            {description && <p className='my-9 leading-relaxed md:text-xl lg:text-3xl'>{description}</p>}
        </div>
    );
}

export default TitleDescription;
